import { isHeziNative } from '@remote/utils/platform'
export * from './platform'

export function isOpenInThunderBrower (): boolean {
  return window.navigator.userAgent.includes('TBC') && document?.documentElement?.clientWidth >= 1100
}

export function isLargeViewPort (): boolean {
  return !isHeziNative && document?.documentElement?.clientWidth >= 1100
}

export function isMobile (): boolean {
  const ua = window.navigator.userAgent
  return /ip(hone|od|ad)|android/.test(ua.toLowerCase()) || !isLargeViewPort()
}

export const requestAnimationFrame = window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  window.mozRequestAnimationFrame ||
  function (callback) {
    window.setTimeout(callback, 1000 / 60)
  }

export const clearTimeout = (id) => {
  const cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.clearInterval
  if (id) {
    cancelAnimationFrame(id)
    window.clearTimeout(id)
  }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const noop = (..._args: unknown[]): unknown => undefined

export const delay = (t: number) => {
  return new Promise(r => {
    setTimeout(r, t)
  })
}

export function querys2json (url: string): { [propName: string]: string } {
  // const queryStr = decodeURIComponent(url)?.replace(/(.*\?)/g, '')
  const queryStr = url?.replace(/([^?]*\?)/, '')
  const ary = queryStr.split('&')
  return ary.reduce((prev, next) => {
    const [key, value] = next.split('=')
    prev[key] = decodeURIComponent(value)
    return prev
  }, {})
}

export function json2querys (data: any) {
  const params = Object.keys(data).map((k) => {
    const v = data[k]
    if (typeof v === 'object') {
      if (v) return `${k}=${JSON.stringify(v)}`
      // v is null
      return k
    } else {
      if (v) return `${k}=${v}`
      // eslint-disable-next-line no-self-compare
      if (v !== v) return `${k}=${v}`
      if (v === 0) return `${k}=${v}`
      if (v === false) return `${k}=${v}`
      return k
    }
  })
  return params.join('&')
}

/** 将对象中的数字类型转换为字符串类型（用于接口提交参数转换） */
export function numberToStringWithinObject (obj: object): object {
  return Object.keys(obj).reduce<object>((result, k) => {
    result[k] = typeof obj[k] === 'number' ? String(obj[k]) : obj[k]
    return result
  }, {})
}

/** 对数字num保留小数点后e位（直接截取） */
export function interceptDigital (num: number, e: number) {
  if (e === 0) return num | 0
  const base = 10 ** e
  const result = ((num * base) | 0) / base
  return result
}

/** 用户当出现错误时，获取错误对象的消息提示 */
export function getErrorMessage (err) {
  if (typeof err === 'string') return err
  if (err instanceof Error) return err.message
  if (err && typeof err === 'object' && err.message) return err.message
  return String(err)
}

export function onceExecuteAtATime<T> (fn: (..._args: any[]) => Promise<T>) {
  let isLock = false
  const resolves: Function[] = []
  const rejects: Function[] = []
  const proxyFunction = (...args: any[]): Promise<T> => {
    if (isLock) {
      return new Promise((resolve, reject) => {
        resolves.push(resolve)
        rejects.push(reject)
      })
    }
    isLock = true
    return fn(...args).then((data: T) => {
      resolves.forEach(resovle => {
        resovle(data)
      })
      resolves.length = 0
      return data
    }).catch(err => {
      rejects.forEach(reject => {
        reject(err)
      })
      rejects.length = 0
      throw err
    }).finally(() => {
      isLock = false
    })
  }

  return new Proxy(proxyFunction, {
    get: function (_target, prop) {
      return Reflect.get(fn, prop)
    },
  })
}
